import React from 'react';
import OfficerAssessmentDetailsForm from '../OfficerAssessmentDetailsForm';
const OfficerAssessmentDetailsFormWrapper = ({ officerAssessment, }) => (React.createElement(OfficerAssessmentDetailsForm, { hazards: officerAssessment.hazards, actionTypes: officerAssessment.action_type ? [officerAssessment.action_type] : [], canEdit: false }));
export default OfficerAssessmentDetailsFormWrapper;
